import { LegalTermType, type LegalTerm } from '~/domain/dashboard/app/apps/models/LegalTerm'

export const STORE_EDITABLE_LEGAL_TERM_TYPES = [
  LegalTermType.TermsOfUse,
  LegalTermType.PrivacyPolicy
] as const

export type StoreEditableLegalTermType = typeof STORE_EDITABLE_LEGAL_TERM_TYPES[number]

export type StoreLegalTermsModel = Record<StoreEditableLegalTermType, LegalTerm>

const DEFAULT_LEGAL_TERM_TITLES: Record<StoreEditableLegalTermType, string> = {
  [LegalTermType.TermsOfUse]: 'Termos de Uso',
  [LegalTermType.PrivacyPolicy]: 'Política de Privacidade'
}

export function createEmptyLegalTerm (type: StoreEditableLegalTermType, appId?: number): LegalTerm {
  return {
    type,
    title: DEFAULT_LEGAL_TERM_TITLES[type],
    text: '',
    appId
  }
}

export function createDefaultLegalTerms (appId?: number): StoreLegalTermsModel {
  return {
    [LegalTermType.TermsOfUse]: createEmptyLegalTerm(LegalTermType.TermsOfUse, appId),
    [LegalTermType.PrivacyPolicy]: createEmptyLegalTerm(LegalTermType.PrivacyPolicy, appId)
  }
}

export function mapLegalTermsFromList (terms: LegalTerm[], appId?: number): StoreLegalTermsModel {
  const mapped = createDefaultLegalTerms(appId)

  for (const term of terms) {
    if (term.type === LegalTermType.TermsOfUse || term.type === LegalTermType.PrivacyPolicy) {
      mapped[term.type] = { ...term, appId: appId ?? term.appId }
    }
  }

  return mapped
}

export function ensureStoreSettingsLegalTerms<T extends { app?: { id?: number }; legalTerms?: StoreLegalTermsModel }> (
  model: T
): T & { legalTerms: StoreLegalTermsModel } {
  if (model.legalTerms) {
    return model as T & { legalTerms: StoreLegalTermsModel }
  }

  return {
    ...model,
    legalTerms: createDefaultLegalTerms(model.app?.id)
  }
}
